import Button from "e.sic-platform.webclient/src/components/button/Button";
import { Detection } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";

export default function RunVideoSegmentationButton(props:{onClick: () => void, disabled?: boolean}) {
  const { themeClass } = useThemeService();

  return (
    <Button
        id="run-segmentation-sc"
        onClick={props.onClick}
        disabled={props.disabled}
        icon={{
          svg: Detection,
          textKey: "RunHighlightDetectionButton.run",
          className: themeClass(["icon-custom"]),
        }}
        className={themeClass(["btn-huge", "run-ai-button"])}
      />
  )
}
